import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
  },
  balanceContainer: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'unset',
    },
  },
  amount: {
    fontFamily: '"Bebas Neue"',
  },
  exchangeRateContainer: {
    display: 'flex',

    [theme.breakpoints.up('sm')]: {
      justifyContent: 'center',
    },
  },
  hint: {
    color: theme.palette.text.disabled,
  },
}));
